<div class="container">
  <div class="voucher d-flex flex-lg-row flex-column align-items-center">
    <!-- <div class="col-lg-1"></div> -->
    <div class="voucher-title d-flex flex-column">
      <h5 class="voucher-title-text text-white font-size-16 text-uppercase mb-0 fw-bold">
        {{ 'voucher.code.title' | translate }}
      </h5>
      <span class="voucher-title-description text-white font-size-14">{{ 'voucher.enter.code.here' | translate }}</span>
    </div>
    <div class="voucher-box d-flex flex-column align-items-center">
      <div class="voucher-input">
        <input
          type="text"
          [(ngModel)]="voucherCode"
          placeholder="Insert Code Here"
          class="form-control border-0"
          (keyup.enter)="redeemVoucher()"
          [disabled]="disableButton"
        />
        <button
          class="voucher-submit text-primary border-0 icon material-icons"
          (click)="redeemVoucher()"
          [disabled]="disableButton"
        >
          navigate_next
        </button>
      </div>
      <div class="result-box pt-1 text-center">
        <div class="result mt-0">
          <div class="font-size-12 text-white mb-3">
            {{ redemptionResult }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
